export const MassageIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.82 18.39C12.26 18.45 12.71 18.48 13.17 18.48L17.36 20.97C18.07 21.4 18.96 20.82 18.86 19.99L18.47 16.83C20.61 15.33 22 12.94 22 10.24C22 5.68999 18.05 2 13.17 2C8.29 2 4.34 5.68999 4.34 10.24C4.34 10.5 4.35 10.75 4.38 11M11.82 18.39C12.56 17.52 13 16.42 13 15.23C13 12.39 10.54 10.09 7.5 10.09C6.34 10.09 5.27 10.42 4.38 11M11.82 18.39C10.83 19.59 9.26 20.36 7.5 20.36L4.89 21.91C4.45 22.18 3.89 21.81 3.95 21.3L4.2 19.33C2.86 18.4 2 16.91 2 15.23C2 13.47 2.94 11.92 4.38 11"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
